// src/pages/Deposit/components/CurrencySelect.jsx
export default function CurrencySelect({ selected, onChange }) {
  const currencies = [
    { code: 'usd', name: 'USD - US Dollar' },
    { code: 'eur', name: 'EUR - Euro' },
    { code: 'gbp', name: 'GBP - British Pound' },
    { code: 'jpy', name: 'JPY - Japanese Yen' }
  ];

  return (
    <div className="mb-4">
      <label className="block text-zinc-300 mb-2" htmlFor="currency">
        Currency
      </label>
      <select
        id="currency"
        value={selected}
        onChange={(e) => onChange(e.target.value)}
        className="w-full bg-zinc-800 border border-zinc-700 text-white rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-purple-500"
      >
        {currencies.map((currency) => (
          <option key={currency.code} value={currency.code}>
            {currency.name}
          </option>
        ))}
      </select>
    </div>
  );
}
